export default __webpack_public_path__ + "locales/nl/UploadPanel.json?hash=63dc8361e0a3e5fd54e10738050bdc96";